module.exports = __webpack_public_path__ + "static/media/star11.fb11cb66.svg";